import React from 'react';
import { Helmet } from 'react-helmet-async';
import TopHeader from './TopHeader';
import Vision from './Vision';
import WhyChooseUs from './WhyChooseUs';
import TestimonialsN from '../Dashboard/TestimonialsN';
import OurTeam from './OurTeam';
import aboutbanner from '../../assets/images/AboutUss.png';

const About: React.FC = () => {
    return (
        <div>
            <Helmet>
                <title>Hyderabad's Real Estate Company | Best apartments & villas</title>
                <meta name="description" content="Find the best properties - Villas, Apartments and Flats from one of the top real estate companies in Hyderabad. Your dream home is just a click away." />
                <meta name="keywords" content="real estate companies in hyderabad, real estate firms in hyderabad, real estate agencies in hyderabad, top 10 real estate companies in hyderabad, top real estate companies in hyderabad, best real estate company in hyderabad, best properties in hyderabad, apartments for sale in hyderabad, best flats in hyderabad, best villas in hyderabad, Kokapet, Kondapur, Gachibowli, Mokila, Shamshabad, Future City Hyderabad" />
            </Helmet>
            <TopHeader value="About Us" backgroundImage={aboutbanner} />
            <Vision />
            <WhyChooseUs />
            <TestimonialsN />
            <OurTeam />
        </div>
    );
};

export default About;
